import React from 'react'

function ViewSallerBankDetail({ user, closeModal }) {
  if (!user) return null;
  function formatDateTime(isoString) {
    const date = new Date(isoString);
    const formattedDate = date.toLocaleDateString();
    const formattedTime = date.toLocaleTimeString();
    return { date: formattedDate, time: formattedTime };
  }
  const { date, time } = formatDateTime(user?.createdAt);
  return (
    <div className="modal fade viewbox edit-box show d-block" id="manufacturerModal" tabIndex={-1} aria-labelledby="manufacturerModal" aria-hidden="true" >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="manufacturerModal"> Seller Bank Details</h5>
            <button type="button" className="btn-close" onClick={closeModal} aria-label="Close"></button>
          </div>
          <div className="modal-body px-5">
            <div className="d-box mt-3 pt-1">
              <ul className="d-flex flex-wrap list-unstyled justify-content-between">

                <li><strong>Account Holder:</strong> {user?.accountHolderName || "N/A"}</li>

                <li><strong>Bank Name:</strong> {user?.bankName || "N/A"}</li>

                <li><strong>Account Number:</strong> {user?.accountNumber || "N/A"}</li>

                <li><strong>IFSC Code:</strong> {user?.ifscCode || "N/A"}</li>

                <li><strong>Branch:</strong> {user?.branchName || "N/A"}</li>

                <li><strong>Status:</strong> {user?.status || "N/A"}</li>

                <li>
                  <strong>Primary Account:</strong>
                  {user?.isPrimary ? "Yes ✅" : "No ❌"}
                </li>

                <li>
                  <strong>Seller Name:</strong>
                  {user?.sellerId
                    ? `${user?.sellerId?.firstName || ""} ${user?.sellerId?.lastName || ""}`
                    : "N/A"}
                </li>

                <li>
                  <strong>Seller Mobile:</strong>
                  {user?.sellerId?.mobileNo || "N/A"}
                </li>

                <li><strong>Created Date:</strong> {user?.createdAt ? date : "N/A"}</li>

              </ul>

            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ViewSallerBankDetail